import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatHttpService {

  constructor(private http: HttpClient) { }

  getMessages(conv_id:any):Observable<any>{
    return this.http.post(`api/assistant/get`,{conv_id});
  }

  sendMessage(payload:any) {
    return this.http.post(`api/assistant/answer`,payload);
  }

  getHistory():Observable<any>{
    console.log('getting history')
    return this.http.get(`api/assistant/history`);
  }
}
